import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Benefits = () => (
  <div className="mt-6 bg-white border border-green-200 rounded-2xl p-5 text-left" data-testid="confirm-benefits">
    <p className="font-bold text-green-900 text-sm">🌳 A HeveaTalent é grátis e feita para a heveicultura:</p>
    <ul className="mt-3 space-y-2 text-sm text-gray-700">
      <li>🤝 <b>Balcão de Empregos</b> — vagas e profissionais de sangria em um só lugar</li>
      <li>📅 <b>Calendário e gestão</b> — anote produção, chuvas e os dados diários da sangria</li>
      <li>📰 <b>Comunidade</b> — notícias do setor, dicas práticas, curta e comente</li>
      <li>📈 <b>Preços e tendências</b> — acompanhe o mercado da borracha</li>
    </ul>
    <a
      href="/?cadastro=vaga"
      className="mt-4 block w-full text-center bg-green-700 hover:bg-green-800 text-white font-bold py-3 rounded-xl text-sm"
      data-testid="confirm-register-cta"
    >
      Criar minha conta grátis →
    </a>
  </div>
);

export default function ConfirmarAnuncioPage() {
  const { token } = useParams();
  const [ad, setAd] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const [step, setStep] = useState("ask");
  const [sending, setSending] = useState(false);
  const [form, setForm] = useState({ city: "", plantas: "", facas: "", vagas: "", reference_name: "", reference_phone: "", reference_farm: "" });

  useEffect(() => {
    axios.get(`${API}/public/confirmar/${token}`)
      .then((r) => setAd(r.data))
      .catch(() => setNotFound(true));
  }, [token]);

  const answer = async (available) => {
    setSending(true);
    try {
      await axios.post(`${API}/public/confirmar/${token}/responder`, { available });
      setStep(available ? "yes" : "no");
    } catch { /* mantém tela */ }
    setSending(false);
  };

  const sendDetails = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await axios.post(`${API}/public/confirmar/${token}/detalhes`, form);
      setStep("done");
    } catch { /* mantém tela */ }
    setSending(false);
  };

  if (notFound) {
    return (
      <div className="min-h-screen bg-green-50 flex items-center justify-center p-6">
        <div className="text-center" data-testid="confirm-not-found">
          <p className="text-4xl">🔎</p>
          <p className="mt-2 font-bold text-gray-900">Link não encontrado</p>
          <p className="text-sm text-gray-600 mt-1">Este link de confirmação não existe ou já expirou.</p>
          <a href="/balcao" className="mt-4 inline-block text-green-700 font-semibold underline text-sm">Ir para o Balcão de Empregos →</a>
        </div>
      </div>
    );
  }

  if (!ad) {
    return <div className="min-h-screen bg-green-50 flex items-center justify-center text-gray-500 text-sm">Carregando…</div>;
  }

  const isVaga = ad.kind === "vaga";

  return (
    <div className="min-h-screen bg-green-50" data-testid="confirmar-page">
      <header className="bg-green-900 text-white py-4 px-4 text-center">
        <p className="font-bold text-lg">🌳 HeveaTalent</p>
        <p className="text-green-200 text-xs">Balcão de Empregos da Heveicultura — gratuito</p>
      </header>

      <main className="max-w-md mx-auto p-4 pb-10">
        {step === "ask" && (
          <>
            <p className="text-sm text-gray-700 mt-2 text-center">
              Olá! 👋 Estamos divulgando seu anúncio <b>gratuitamente</b> no Balcão de Empregos da HeveaTalent,
              uma plataforma que conecta fazendas e profissionais da seringueira.
            </p>

            <div className="mt-4 bg-white border-2 border-green-600 rounded-2xl p-4 shadow-sm" data-testid="confirm-ad-card">
              <span className={`inline-block px-2 py-0.5 rounded-full text-[10px] font-bold text-white ${isVaga ? "bg-sky-600" : "bg-amber-600"}`}>
                {isVaga ? "VAGA DE EMPREGO" : "OFERTA DE TRABALHO"}
              </span>
              <p className="font-bold text-gray-900 mt-2">{ad.title}</p>
              {ad.summary && <p className="text-sm text-gray-600 mt-1">{ad.summary}</p>}
              <p className="text-xs text-gray-500 mt-2">
                {ad.city ? `📍 ${ad.city} · ` : ""}publicado em {ad.created_at ? new Date(ad.created_at).toLocaleDateString("pt-BR") : "—"}
              </p>
            </div>

            <p className="mt-5 text-center font-bold text-gray-900">
              {isVaga ? "Esta vaga ainda está disponível?" : "Você ainda está disponível para trabalho?"}
            </p>
            <p className="text-center text-xs text-gray-500 mt-1">Só precisamos desta resposta — leva 5 segundos.</p>

            <div className="mt-4 space-y-3">
              <button
                onClick={() => answer(true)}
                disabled={sending}
                className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-4 rounded-2xl text-base disabled:opacity-60"
                data-testid="confirm-yes-btn"
              >
                ✅ Sim, ainda está disponível
              </button>
              <button
                onClick={() => answer(false)}
                disabled={sending}
                className="w-full bg-white border-2 border-gray-300 hover:bg-gray-50 text-gray-800 font-bold py-4 rounded-2xl text-base disabled:opacity-60"
                data-testid="confirm-no-btn"
              >
                {isVaga ? "❌ Não, a vaga já foi preenchida" : "❌ Não, já consegui serviço"}
              </button>
            </div>
            {ad.status === "closed" && (
              <p className="mt-3 text-center text-xs text-amber-700" data-testid="confirm-closed-hint">
                ℹ️ Este anúncio está fora do ar no momento — respondendo ✅ ele volta a aparecer hoje.
              </p>
            )}
          </>
        )}

        {step === "yes" && (
          <>
            <div className="mt-4 bg-green-100 border border-green-300 rounded-2xl p-4 text-center" data-testid="confirm-yes-success">
              <p className="text-3xl">✅</p>
              <p className="font-bold text-green-900 mt-1">Obrigado! Anúncio renovado hoje.</p>
              <p className="text-sm text-green-800 mt-1">Ele continua no ar com o selo de disponibilidade confirmada.</p>
            </div>

            <form onSubmit={sendDetails} className="mt-5 bg-white border border-gray-200 rounded-2xl p-4" data-testid="confirm-details-form">
              <p className="font-bold text-gray-900 text-sm">Quer deixar seu anúncio mais completo? <span className="font-normal text-gray-500">(opcional — atrai mais {isVaga ? "candidatos" : "fazendas"})</span></p>
              <div className="mt-3 space-y-3">
                <input
                  value={form.city}
                  onChange={(e) => setForm({ ...form, city: e.target.value })}
                  placeholder="Cidade / região"
                  className="w-full border rounded-xl px-3 py-2.5 text-sm"
                  data-testid="confirm-city-input"
                />
                <input
                  value={form.plantas}
                  onChange={(e) => setForm({ ...form, plantas: e.target.value })}
                  placeholder={isVaga ? "Nº de plantas da propriedade (ex: 15 mil)" : "Nº de plantas que consegue sangrar (ex: 5 mil)"}
                  className="w-full border rounded-xl px-3 py-2.5 text-sm"
                  data-testid="confirm-plantas-input"
                />
                {isVaga ? (
                  <input
                    value={form.vagas}
                    onChange={(e) => setForm({ ...form, vagas: e.target.value })}
                    placeholder="Quantas vagas / facas (ex: 2 facas)"
                    className="w-full border rounded-xl px-3 py-2.5 text-sm"
                    data-testid="confirm-vagas-input"
                  />
                ) : (
                  <input
                    value={form.facas}
                    onChange={(e) => setForm({ ...form, facas: e.target.value })}
                    placeholder="Quantas facas você atende (ex: 1 faca)"
                    className="w-full border rounded-xl px-3 py-2.5 text-sm"
                    data-testid="confirm-facas-input"
                  />
                )}
                {!isVaga && (
                  <div className="border-t pt-3">
                    <p className="text-xs font-semibold text-gray-700">⭐ Referência de um ex-empregador (dá mais credibilidade ao seu anúncio)</p>
                    <div className="mt-2 space-y-2">
                      <input
                        value={form.reference_name}
                        onChange={(e) => setForm({ ...form, reference_name: e.target.value })}
                        placeholder="Nome do ex-empregador"
                        className="w-full border rounded-xl px-3 py-2.5 text-sm"
                        data-testid="confirm-ref-name-input"
                      />
                      <input
                        value={form.reference_phone}
                        onChange={(e) => setForm({ ...form, reference_phone: e.target.value })}
                        placeholder="Telefone dele (com DDD)"
                        className="w-full border rounded-xl px-3 py-2.5 text-sm"
                        data-testid="confirm-ref-phone-input"
                      />
                      <input
                        value={form.reference_farm}
                        onChange={(e) => setForm({ ...form, reference_farm: e.target.value })}
                        placeholder="Fazenda / propriedade (opcional)"
                        className="w-full border rounded-xl px-3 py-2.5 text-sm"
                        data-testid="confirm-ref-farm-input"
                      />
                    </div>
                  </div>
                )}
              </div>
              <button
                type="submit"
                disabled={sending}
                className="mt-4 w-full bg-green-700 hover:bg-green-800 text-white font-bold py-3 rounded-xl text-sm disabled:opacity-60"
                data-testid="confirm-details-send-btn"
              >
                Enviar detalhes
              </button>
              <button
                type="button"
                onClick={() => setStep("done")}
                className="mt-2 w-full text-gray-500 text-xs underline"
                data-testid="confirm-details-skip-btn"
              >
                Agora não, obrigado
              </button>
            </form>
          </>
        )}

        {step === "no" && (
          <div className="mt-4 bg-white border border-gray-200 rounded-2xl p-5 text-center" data-testid="confirm-no-success">
            <p className="text-3xl">🙏</p>
            <p className="font-bold text-gray-900 mt-1">Obrigado por avisar!</p>
            <p className="text-sm text-gray-600 mt-1">
              {isVaga
                ? "Removemos o anúncio do Balcão. Quando tiver uma nova vaga, publique grátis — leva 1 minuto."
                : "Removemos o anúncio do Balcão. Quando procurar serviço de novo, anuncie grátis — leva 1 minuto."}
            </p>
          </div>
        )}

        {step === "done" && (
          <div className="mt-4 bg-green-100 border border-green-300 rounded-2xl p-5 text-center" data-testid="confirm-done">
            <p className="text-3xl">🌳</p>
            <p className="font-bold text-green-900 mt-1">Tudo certo, obrigado!</p>
            <p className="text-sm text-green-800 mt-1">Seu anúncio está atualizado no Balcão de Empregos.</p>
          </div>
        )}

        {step !== "ask" && <Benefits />}
      </main>
    </div>
  );
}
